module.exports = require("core-js/modules/es.json.stringify.js");